import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

class AgendaSingleItemDates extends Component {
	getPostDateBegin = () => {
		try {
			if (this.props.postItem &&
				this.props.postItem._source &&
				this.props.postItem._source.date_begin) {
				const firstDate = this.props.postItem._source.date_begin.split(' ')[0].trim()
				if (firstDate) {
					const dateBegin = new Date(firstDate)
					if (!isNaN(dateBegin.getTime())) {
						return new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: 'short', timeZone: 'Europe/Paris' }).format(dateBegin)
					}
				}
			}
			return ''
		} catch (error) {
			console.error("Error getting post date begin:", error)
			return ''
		}
	}

	getPostDateEnd = () => {
		try {
			if (this.props.postItem &&
				this.props.postItem._source &&
				this.props.postItem._source.date_begin &&
				this.props.postItem._source.date_end) {
				const firstDate = this.props.postItem._source.date_begin.split(' ')[0].trim()
				const lastDate = this.props.postItem._source.date_end.split(' ')[0].trim()

				if (lastDate) {
					const dateEnd = new Date(lastDate)
					if (!isNaN(dateEnd.getTime())) {
						const dateEndReturn = Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: 'short', timeZone: 'Europe/Paris' }).format(dateEnd)
						const dateBegin = new Date(firstDate)
						if (!isNaN(dateBegin.getTime())) {
							const dateBeginCheck = Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: 'short', timeZone: 'Europe/Paris' }).format(dateBegin)
							if (dateEndReturn !== dateBeginCheck) {
								return dateEndReturn
							} else {
								// Si c'est le même jour, retourner l'heure de début
								const timeBegin = this.props.postItem._source.date_begin.split(' ')[1]
								return timeBegin || ''
							}
						}
					}
				}
			}
			return ''
		} catch (error) {
			console.error("Error getting post date end:", error)
			return ''
		}
	}

	showEndAlert = () => {
		try {
			if (this.props.postItem &&
				this.props.postItem._source &&
				this.props.postItem._source.date_end) {
				const lastDate = this.props.postItem._source.date_end.split(' ')[0]
				if (lastDate) {
					const currentTime = new Date()
					const lastDateTime = new Date(lastDate)

					if (!isNaN(lastDateTime.getTime())) {
						// Comparer seulement les dates (sans l'heure)
						const currentDate = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate())
						const eventDate = new Date(lastDateTime.getFullYear(), lastDateTime.getMonth(), lastDateTime.getDate())

						if (eventDate < currentDate) {
							return (
								<div
									className="agenda-covid"
									role="alert"
									aria-live="polite"
									aria-label="Attention - Événement passé"
								>
									<p className="section-title">
										<span>Attention</span>
									</p>
									<p className="section-text">
										<span className="text-bold">
											La date de cet évènement est passée, n'hésitez pas à consulter l'agenda en cliquant{' '}
											<Link
												className="agenda-covid-link"
												to="/agenda/"
												aria-label="Consulter l'agenda des événements"
											>
												ici
											</Link>
										</span>
										<br />
									</p>
								</div>
							)
						}
					}
				}
			}
			return null
		} catch (error) {
			console.error("Error showing end alert:", error)
			return null
		}
	}

	render = () => {
		try {
			const dateBegin = this.getPostDateBegin()
			const dateEnd = this.getPostDateEnd()

			// Rendre le composant même si une seule date est disponible
			if (!dateBegin && !dateEnd) {
				return null
			}

			return (
				<div
					className="agenda-single-item-dates"
					role="region"
					aria-label={`Dates de l'événement: du ${dateBegin || 'date inconnue'} au ${dateEnd || 'date inconnue'}`}
				>
					{this.showEndAlert()}
					<p className="agenda-single-item-dates-content">
						{dateBegin && (
							<span className="agenda-single-item-dates-begin">{dateBegin}</span>
						)}
						{dateBegin && dateEnd && (
							<span className="agenda-single-item-dates-sepa"> -- </span>
						)}
						{dateEnd && (
							<span className="agenda-single-item-dates-end">{dateEnd}</span>
						)}
					</p>
				</div>
			)
		} catch (error) {
			console.error("Error rendering AgendaSingleItemDates:", error)
			return null
		}
	}
}

AgendaSingleItemDates.propTypes = {
	postItem: PropTypes.shape({
		_source: PropTypes.shape({
			date_begin: PropTypes.string,
			date_end: PropTypes.string
		})
	})
}

AgendaSingleItemDates.defaultProps = {
	postItem: null
}

export default AgendaSingleItemDates;
